/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import {
  IMSDashboard,
  MMSDashboard,
  PMSDashboard,
} from '../../components/Dashboards';
import { Error } from '../../components/Error';
import Loading from '../../components/Loading';
import { ViewTitle } from '../../components/ViewTitle';
import * as actions from '../../redux/actions';
import { MATERIAL_REQUEST_STATUS, ORDER_STATUS } from '../../utils/constants';
import { getStorage, setStorage } from '../../utils/functions/localstorage';

function MainDashboard({ title, subtitle }) {
  const dispatch = useDispatch();
  const employee = useSelector((state) => state.employee);
  const materialRequest = useSelector((state) => state.materialRequest);
  const manufacturingOrder = useSelector((state) => state.manufacturingOrder);
  const material = useSelector((state) => state.material);
  const step = useSelector((state) => state.step);
  const me = useSelector((state) => state.me);

  const isFullCalendar = getStorage('full_calendar');
  const [startDate, setStartDate] = useState(
    dayjs().startOf('month').toISOString(),
  );
  const [periodText, setPeriodText] = useState('ในเดือนล่าสุด');
  const [endDate, setEndDate] = useState(dayjs().endOf('month').toISOString());

  // console.log('isFullCalendar', isFullCalendar);

  useEffect(() => {
    const fetchMaterterialRequest = async () => {
      try {
        await dispatch(
          actions.materialRequestAll({
            statusCode: MATERIAL_REQUEST_STATUS.PENDING_APPROVAL.status_code,
            startDate,
            endDate,
          }),
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchOrder = async () => {
      try {
        await dispatch(
          actions.orderAll({
            statusCode: ORDER_STATUS.ORDER_CREATE.status_code,
            startDate,
            endDate,
          }),
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchManufacturingOrder = async () => {
      try {
        await dispatch(
          actions.manufacturingOrderAll({ all: true, startDate, endDate }),
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchMaterial = async () => {
      try {
        await dispatch(actions.materialAll({}));
      } catch (error) {
        console.error(error);
      }
    };

    const fetchStep = async () => {
      try {
        await dispatch(actions.stepAll({ all: true, startDate, endDate }));
      } catch (error) {
        console.error(error);
      }
    };

    const fetchMe = async () => {
      try {
        await dispatch(actions.meGet(''));
      } catch (error) {
        console.error(error);
      }
    };

    const fetchEmployee = async () => {
      try {
        await dispatch(actions.employeeAll({}));
      } catch (error) {
        console.error(error);
      }
    };

    const checkFullCalendar = async () => {
      if (!isFullCalendar) {
        await setStorage('full_calendar', true);
      }
    };

    checkFullCalendar();
    fetchEmployee();
    fetchManufacturingOrder();
    fetchOrder();
    fetchMaterterialRequest();
    fetchMaterial();
    fetchStep();
    fetchMe();
    return () => {};
  }, [startDate, endDate]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const handleChangePeriod = (value) => {
    if (value === 'week') {
      setStartDate(dayjs().startOf('week').toISOString());
      setEndDate(dayjs().endOf('week').toISOString());
      setPeriodText('ในสัปดาห์ล่าสุด');
    } else if (value === 'month') {
      setStartDate(dayjs().startOf('month').toISOString());
      setEndDate(dayjs().endOf('month').toISOString());
      setPeriodText('ในเดือนล่าสุด');
    } else if (value === 'year') {
      setStartDate(dayjs().startOf('year').toISOString());
      setEndDate(dayjs().endOf('year').toISOString());
      setPeriodText('ในปีล่าสุด');
    }
  };
  const renderPeriod = () => (
    <div>
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel id="type" size={'small'}>
          ช่วงเวลา
        </InputLabel>
        <Select
          label="ช่วงเวลา"
          size={'small'}
          fullWidth
          defaultValue="month"
          onChange={(e) => {
            handleChangePeriod(e.target.value);
          }}
        >
          <MenuItem value="week">สัปดาห์ล่าสุด</MenuItem>
          <MenuItem value="month">เดือนล่าสุด</MenuItem>
          <MenuItem value="year">ปีล่าสุด</MenuItem>
        </Select>
      </FormControl>
    </div>
  );

  if (
    me.isLoading &&
    material.isLoading &&
    step.isLoading &&
    employee.isLoading &&
    manufacturingOrder.isLoading
  ) {
    return <Loading />;
  }
  if (
    me.isCompleted &&
    me.isCompleted &&
    material.isCompleted &&
    step.isCompleted &&
    employee.isCompleted &&
    manufacturingOrder.isCompleted
  ) {
    return (
      <div>
        {renderTitle()}
        <div className="flex justify-end my-2">{renderPeriod()}</div>
        <PMSDashboard
          materialRequest={materialRequest}
          periodText={periodText}
        />
        <MMSDashboard
          employee={employee}
          manufacturingOrder={manufacturingOrder}
          periodText={periodText}
          step={step}
        />
        <IMSDashboard material={material} />
      </div>
    );
  }
  return <Error />;
}
MainDashboard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

MainDashboard.defaultProps = {
  title: '',
  subtitle: '',
};

export default MainDashboard;
